import './testimonials.css'
import Testimonial from './Testimonial';

import testimonials from './data'
const Testimonials = () => {
  return (
    <section id="testimonials">
      <h2>What Collaborators Say</h2>
      <p>
        A few words from people I have worked and learned with.
      </p>
      <div className="container testimonials__container">
        <div className="testimonials__grid">
        {
          testimonials.map(testimonial => (
            <Testimonial key={testimonial.id} testimonial={testimonial}/>
          ))
        }
        </div>
      </div>
    </section>
  )
}

export default Testimonials